import React from 'react';
import {useState} from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import img1 from '../assets/Nfts/mint.png';
import img2 from '../assets/Nfts/cloud_2.png';
import {ethers, BigNumber} from 'ethers';
import aioo from '../aioo.json';
//import Buttonred from '../components/Buttonred'
//import { Contract } from '@ethersproject/contracts'

//const aiooAdress ="0xF480ce95ebBA7675Ee1b9129A1C3DbC8F0E4b417";
const aiooAdress = "0xB966c0Cd7aaCBE48df7f0758b90Ac63d6359D810";

//const ImgContainer = styled.img`

const Container = styled.div`
width: 100%

`
const Amountbox = styled.div`
width: 100%;
text-align: center;
display: flex;

justify-content: center;

@media (max-width: 48em)
  {
    
    display: none;

    
    }

`
const Buttondec = styled.div`
width: 100px;
height: 75px;
font-size: ${props => props.theme.fontxxxl};
background-color: #ffd94a;
border-size: 1px;
display: flex;

cursor: Pointer;
justify-content: center;
text-align: center;

`

const SubText = styled.p`
font-size: ${props => props.theme.fontlg};

width: 80%;
color: #000000;
align-self: flex-start;
margin: 1rem auto;
@media (max-width: 64em){
  align-self: center;
  text-align: center;
  font-size: ${props => props.theme.fontlg};
  }

`

const SubTextLight = styled.p`
font-size: ${props => props.theme.fontmd};

width: 80%;
color: #333333;
align-self: flex-start;
align-items: center;
margin: 1rem auto;
@media (max-width: 64em){
  align-self: center;
  text-align: center;
  }

  @media (max-width: 48em)
  {
    
    display: none;

    
    }
`
const LogoText = styled.div`
width: auto;
margin: 2rem;

text-align: center;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
transition: all .4s ease;
cursor: Pointer;
&:hover{
  transform: scale(1.05);
  }

`
const ContBox = styled.div`
width: 100%;

text-align: center;
align-items: center;
justify-content: center;
display: flex;
transition: all .4s ease;
cursor: Pointer;


@media (max-width: 48em)
  {
    
    display: none;

    
    }
  

`


const Title = styled.div`
width: 200px;
height: 75px;
font-family: "Caveat Brush", cursive;
font-size: ${props => props.theme.fontxxxl};
background-color: #ffffff;

text-align: center;

color: #000000;

margin: 0 auto;

`

const MintButton = ({accounts, setAccounts}) => {

  const [account, setAccount] = useState(null);
  const initConnection = async () => {
    if(typeof window.ethereum !== "undefined"){
    const accounts = await window.ethereum.request({
    method: "eth_requestAccounts",
    });
    
      
      setAccount(accounts[0]);
    }
    else {
      console.log("bajs");
    }
    
    }

const [mintAmount, setMintAmount] = useState(1);
//const isConnected = Boolean(accounts[0]);

  async function handleMint() {
    if (window.ethereum){
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(aiooAdress, aioo, signer);
      
try {
 const response = await contract.mint(BigNumber.from(mintAmount), {value: ethers.utils.parseEther((0 * mintAmount).toString()),} );

  console.log('response: bajs5', response)
}
catch (err) {
  console.log('bajs: ')
  console.log("error: ", err)
}
    }
    
  }
  const handleDecrement = () => {
    if (mintAmount <= 1) return;
    setMintAmount(mintAmount - 1);
  };
  const handleIncrement = () => {
    if (mintAmount >= 5) return;
    setMintAmount(mintAmount + 1);
  };
  return (
    
   <Container>
<Link to="/">
    
      </Link>
      <SubTextLight>Max 5 per Wallet</SubTextLight>
<SubText>Free Mint</SubText>

<Amountbox>
<Title>{mintAmount}</Title>
</Amountbox>
<Amountbox>
<Buttondec onClick={handleIncrement}>+</Buttondec>
<Buttondec onClick={handleDecrement}>-</Buttondec>
    </Amountbox>
   
   
   <ContBox> 
   <LogoText onClick={initConnection}>
  <img src={img2} width="150px" alt=""></img>
  </LogoText>

    <LogoText onClick={handleMint}>
  <img src={img1} width="150px" alt=""></img>

  </LogoText>
  
</ContBox>
<SubTextLight>Connected wallet: </SubTextLight>
<SubTextLight>{account}</SubTextLight>
<SubTextLight>Smart contact: 0xB966c0Cd7aaCBE48df7f0758b90Ac63d6359D810</SubTextLight>


   </Container>
   
  )
}

export default MintButton